// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"504":"chunk-vendors","996":"chunk-common","9946":"katex-chunk-17ee6fe8"}[chunkId] + "." + {"504":"94c93221","996":"fc5d8b94","9946":"4741067f"}[chunkId] + ".css";
};